export default __webpack_public_path__ + "static/pop2-90329493ac50795f809fa257c7df792f.wav";